import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { noop } from 'lodash';
import typography from '@ds-typography';

import './PaymentPlanCard.scss';
import Divider from '../Divider/Divider';
import Tag from '../Tag/Tag';
import { PLAN_ENTERPRISE, ORGANIZATION_PLAN_FREE } from '@shared/constants';
import {
  DSChatBubbleSmileIcon,
  DSCheckMarkIcon,
  DSMageStarsIcon
} from '@ds-icons';

const PaymentPlanCard = ({
  activeCard,
  isActivePaymentPlan,
  badgeLabel,
  bulletsTitle,
  bullets,
  color,
  isAcademic,
  priceDescription,
  priceLabel,
  title,
  showTrialButton,
  onTrialClick,
  paymentBullets,
  plan,
  planBenefits,
  onClick,
  disabled,
  isEM,
  panelHasTrialButton,
  isTrial
}) => {
  const onClickHandler = () => {
    if (disabled) return;
    onClick();
  };

  return (
    <div
      className={cx(
        'ds-payment-plan-card',
        { active: activeCard },
        { disabled }
      )}
      style={{ '--card-color': color }}
      onClick={onClickHandler}
    >
      {isActivePaymentPlan && (
        <div
          className={cx('payment-plan-current-badge', {
            activeSelected: activeCard
          })}
        >
          {isTrial ? 'Current Trial' : 'Current Plan'}
        </div>
      )}
      <div className="payment-plan-content-container">
        <div
          className={cx('payment-plan-name-container', {
            'trial-button-exist': panelHasTrialButton
          })}
        >
          <div className="payment-title-container">
            <h2 className="payment-plan-title">{title}</h2>
            {badgeLabel && (
              <Tag
                backgroundColor={color}
                label={badgeLabel}
                color="white"
                marginLeft={8}
                style={{ fontSize: '14px', padding: '4px 8px' }}
              />
            )}
          </div>

          <div className="plan-benefits">{planBenefits}</div>

          {!isAcademic && (
            <div className="payment-price-container">
              {priceLabel && <h1>{priceLabel}</h1>}
              {plan === PLAN_ENTERPRISE && <DSChatBubbleSmileIcon />}
              <span>{priceDescription}</span>
            </div>
          )}

          <div className="payment-description-container">
            <ul className="payment-bullet-list">
              {paymentBullets?.map(bullet => (
                <li key={bullet.label} className="payment-bullet">
                  {bullet.label}
                </li>
              ))}
            </ul>
            {showTrialButton && (
              <div className="card-trial-container">
                <button
                  onClick={onTrialClick}
                  className={cx(typography.dsAccented, typography.dsAction)}
                >
                  Free 30 days trial
                </button>
              </div>
            )}
          </div>
          {isAcademic && (
            <div className="is-academic-container">Free Academic Access</div>
          )}
        </div>
        <Divider orientation="horizontal" margin={32} />
        <div className="payment-bullets-container">
          {bulletsTitle && (
            <div className="payment-bullets-title">{bulletsTitle}</div>
          )}
          {bullets?.map(bullet => (
            <div
              className={cx('payment-bullet', {
                withPadding: !!bullet.withPadding
              })}
              key={bullet.label}
            >
              <DSCheckMarkIcon className="checkMarkIcon" />
              {bullet.label}
            </div>
          ))}
          {plan === ORGANIZATION_PLAN_FREE && isEM && (
            <div className="payment-bullet-llm">
              <DSMageStarsIcon />
              LLM evaluation included for free
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

PaymentPlanCard.propTypes = {
  activeCard: PropTypes.bool,
  isActivePaymentPlan: PropTypes.bool,
  badgeLabel: PropTypes.string,
  bulletsTitle: PropTypes.string,
  bullets: PropTypes.array,
  color: PropTypes.string.isRequired,
  description: PropTypes.string,
  isAcademic: PropTypes.bool,
  label: PropTypes.string,
  priceDescription: PropTypes.string,
  priceLabel: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  showTrialButton: PropTypes.bool,
  onTrialClick: PropTypes.func,
  paymentBullets: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      highlighted: PropTypes.bool
    })
  ),
  planBenefits: PropTypes.string.isRequired,
  plan: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  isEM: PropTypes.bool.isRequired,
  panelHasTrialButton: PropTypes.bool.isRequired,
  isTrial: PropTypes.bool.isRequired
};

PaymentPlanCard.defaultProps = {
  activeCard: false,
  isActivePaymentPlan: false,
  badgeLabel: null,
  bullets: [],
  isAcademic: false,
  priceDescription: '',
  bulletsTitle: '',
  showTrialButton: false,
  onTrialClick: noop
};

export default PaymentPlanCard;
